export default {
  headers: {
    expedient: 'Expediente',
    description: 'Acuerdo',
    amount: 'Anticipo disponible'
  }
}
